export default {
  "notifications.title": "Notifications",
  "notifications.subtitle": "Order and review updates plus the previous notifications log",
  "notifications.all": "View all notifications",
  "notifications.refresh": "Refresh",
  "notifications.listTitle": "Notifications log",

  "notifications.empty": "No notifications yet",
  "notifications.emptyDesc": "Order and review updates will appear here",
  "notifications.error": "Could not load notifications",
  "notifications.targetMissing": "The item linked to this notification could not be reached",
  "notifications.noDestination": "This notification is for reference only and does not open a linked page.",

  "notifications.orderRef": "Order number",
  "notifications.openOrder": "View order",
  "notifications.openReviews": "View reviews",
  "notifications.openDriverReviews": "Driver reviews",

  "notifications.processed": "Handled",
  "notifications.markProcessed": "Mark as handled",
  "notifications.unmarkProcessed": "Undo",
  "notifications.markAllProcessed": "Mark all as handled",

  "notifications.filter.all": "All",
  "notifications.filter.unprocessed": "Open",
  "notifications.filter.processed": "Handled",
  "notifications.filter.empty": "No matching notifications",
  "notifications.filter.emptyDesc": "Pick another filter to see notifications.",

  "notifications.note": "The latest notifications received in the laundry dashboard appear here. You can flag a notification as handled to track what is left.",
  "notifications.live.demo": "Preview an incoming notification",
  "notifications.live.demoHint": "A demo button to preview a live notification arrival.",

  "notifications.type.new_order.title": "A new order needs your decision",
  "notifications.type.new_order.body": "Order {{orderId}} arrived and is awaiting approval or rejection",
  "notifications.type.new_order.bodyGeneric": "A new order arrived and is awaiting approval or rejection",

  "notifications.type.order_handoff.title": "The order was handed to the laundry",
  "notifications.type.order_handoff.body": "The driver confirmed handing order {{orderId}} to the laundry",
  "notifications.type.order_handoff.bodyGeneric": "The driver confirmed handing the order to the laundry",

  "notifications.type.manual_assignment.title": "An order needs a driver assigned",
  "notifications.type.manual_assignment.body": "The customer chose to wait and the grace period ended with no delivery task accepted for order {{orderId}}",
  "notifications.type.manual_assignment.bodyGeneric": "The customer chose to wait and the grace period ended with no delivery task accepted",

  "notifications.type.new_review.title": "A new customer review",
  "notifications.type.new_review.bodyBoth": "{{customerName}} left a {{rating}} out of 5 review",
  "notifications.type.new_review.bodyName": "You received a new review from {{customerName}}",
  "notifications.type.new_review.bodyRating": "You received a new review rated {{rating}} out of 5",
  "notifications.type.new_review.bodyGeneric": "You received a new review from a customer",

  "notifications.type.package_subscription.title": "A new package subscription",
  "notifications.type.package_subscription.bodyBoth": "{{customerName}} subscribed to {{packageName}}",
  "notifications.type.package_subscription.bodyName": "{{customerName}} subscribed to a package",
  "notifications.type.package_subscription.bodyPackage": "A new subscription to {{packageName}}",
  "notifications.type.package_subscription.bodyGeneric": "A customer package subscription notification arrived",

  "notifications.live.alertDemo": "Preview a quick alert",

  "notifications.alert.viewOrder": "View order",
  "notifications.alert.dismiss": "Dismiss alert",

  "notifications.alert.assignment_needed.title": "An order needs a driver assigned",
  "notifications.alert.assignment_needed.body": "Order {{orderId}} waited past the grace period with no delivery task accepted — assign a driver now",
  "notifications.alert.assignment_needed.bodyGeneric": "The wait passed the grace period with no delivery task accepted — assign a driver now",

  "notifications.alert.driver_issue.title": "A problem with the driver",
  "notifications.alert.driver_issue.body": "The driver could not complete the task for order {{orderId}} — review and reassign",
  "notifications.alert.driver_issue.bodyGeneric": "The driver could not complete the task — review and reassign",

  "notifications.alert.delay.title": "Delivery is delayed",
  "notifications.alert.delay.body": "Delivering order {{orderId}} passed the expected time — follow up on the task",
  "notifications.alert.delay.bodyGeneric": "The delivery passed the expected time — follow up on the task",

  "notifications.alert.new_order.title": "A new order arrived",
  "notifications.alert.new_order.body": "Order {{orderId}} arrived and is awaiting approval or rejection",
  "notifications.alert.new_order.bodyGeneric": "A new order arrived and is awaiting approval or rejection"
};